import React from 'react';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'property_reviews',
  namespace: 'propertyReview',
  mountedUrl: '/content/property-reviews',
  title: 'Reviews for properties',
  columns: [
    { attribute: 'date' },
    { attribute: 'property.name', label: 'property' },
    { attribute: 'guest_name', label: 'guest' },
    { attribute: 'language' },
    { attribute: 'validated', label: 'validated', value: (object) => object.validated ? <i className="fas fa-check" /> : null },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-review/containers/Listing.jsx